export default __webpack_public_path__ + "static/media/Photosnap - Preview 1.b009ee01.png";